/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Icon = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M10.8902 9.6L8.4902 16.93H35.5102L33.1102 9.6C32.7002 8.34 31.5802 7.5 30.3302 7.5H13.6702C12.4202 7.5 11.3102 8.34 10.8902 9.6ZM4.8502 17.31L7.64019 9.35C8.7102 6.3 11.5902 4.25 14.8202 4.25H29.1802C32.4102 4.25 35.2902 6.29 36.3602 9.35L39.1502 17.31C40.9902 18.07 42.2902 19.89 42.2902 22V37.21C42.2902 38.61 41.1602 39.75 39.7502 39.75H37.2102C35.8102 39.75 34.6702 38.62 34.6702 37.21V34.67H9.3202V37.21C9.3202 38.61 8.1902 39.75 6.7802 39.75H4.2402C2.8402 39.75 1.7002 38.62 1.7002 37.21V22C1.7002 19.88 3.0002 18.07 4.8402 17.31H4.8502ZM11.8602 25.8C11.8602 24.4 10.7302 23.26 9.3202 23.26C7.9102 23.26 6.7802 24.39 6.7802 25.8C6.7802 27.21 7.9102 28.34 9.3202 28.34C10.7302 28.34 11.8602 27.21 11.8602 25.8ZM34.6802 28.34C36.0802 28.34 37.2202 27.21 37.2202 25.8C37.2202 24.39 36.0902 23.26 34.6802 23.26C33.2702 23.26 32.1402 24.39 32.1402 25.8C32.1402 27.21 33.2702 28.34 34.6802 28.34Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default Icon
